var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C10.3315 0 10.6495 0.131696 10.8839 0.366117C11.1183 0.600537 11.25 0.918479 11.25 1.25V8.75H18.75C19.0815 8.75 19.3995 8.8817 19.6339 9.11612C19.8683 9.35054 20 9.66848 20 10C20 10.3315 19.8683 10.6495 19.6339 10.8839C19.3995 11.1183 19.0815 11.25 18.75 11.25H11.25V18.75C11.25 19.0815 11.1183 19.3995 10.8839 19.6339C10.6495 19.8683 10.3315 20 10 20C9.66848 20 9.35054 19.8683 9.11612 19.6339C8.8817 19.3995 8.75 19.0815 8.75 18.75V11.25H1.25C0.918479 11.25 0.600537 11.1183 0.366117 10.8839C0.131696 10.6495 0 10.3315 0 10C0 9.66848 0.131696 9.35054 0.366117 9.11612C0.600537 8.8817 0.918479 8.75 1.25 8.75H8.75V1.25C8.75 0.918479 8.8817 0.600537 9.11612 0.366117C9.35054 0.131696 9.66848 0 10 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b308b786bd20dee8a86b2dbd6d8ba4bf.svg";
export { ForwardRef as ReactComponent };